'use strict';

frontendApp.factory('UploadService', ['$cookies', 'ConfigService', 'HttpService', function ($cookies, ConfigService, HttpService) {

  // http://blueimp.github.com/jQuery-File-Upload/
  // http://fineuploader.com/#demo

  //http://fineuploader.com/

  var _service = {};
  return _service;
}]);
